// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"FAQDescription_descriptionContainer__cUhJW","descriptionContent":"FAQDescription_descriptionContent__uc5t6","description":"FAQDescription_description__7Co0b"};